import React, { Component } from "react";
import { LogsService } from "app/_services/LogsService/LogsService";
import { mdyhmsDateFormat } from "app/_helpers/helper";

class LastLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastCreateData: {},
      lastApproveData: {},
    };
  }

  componentDidMount() {
    if (this.props.subModulename) {
      this.getLastRecord();
    }
  }

  componentDidUpdate(prev) {
    if (this.props.subModulename && this.props.subModulename !== prev.subModulename) {
      this.getLastRecord();
    }
  }

  async getLastRecord() {
    let obj = {
      submoduleName: this.props.subModulename,
      projectId: this.props.projectId,
    };
    let response = await LogsService.lastRecord(obj);

    if (response && response.status && response.data) {
      this.setState({
        lastCreateData: response.data.lastCreateData,
        lastApproveData: response.data.lastApproveData,
      });
    } else {
      this.setState({
        lastCreateData: {},
        lastApproveData: {},
      });
    }
  }
  render() {
    const { lastCreateData, lastApproveData } = this.state;
    return (
      <div className="logsDetail">
        <p>
          {lastCreateData && lastCreateData.user && (
            <React.Fragment>
              <span>Last Created on</span>
              <strong> {mdyhmsDateFormat(lastCreateData.createdAt)} </strong>
              <span>By</span>
              <strong> {lastCreateData.user.firstName} </strong>
              <span className="ml-2 mr-2">|</span>
            </React.Fragment>
          )}
          {lastApproveData && lastApproveData.user && (
            <React.Fragment>
              <span>Last approved on</span>
              <strong> {mdyhmsDateFormat(lastApproveData.createdAt)} </strong>
              <span>By</span>
              <strong> {lastApproveData.user.firstName} </strong>
            </React.Fragment>
          )}
        </p>
      </div>
    );
  }
}

export default LastLog;
